import { desktopTruncateStyle } from '~/styles/utilities.css';

type Props = {
  extension: string;
};

export const DocumentExtensionCell = ({ extension }: Props) => {
  return <span className={desktopTruncateStyle}>{extension}</span>;
};
